import { UserSettingsMain } from './UserSettingsStyles.styles';
import React, { Suspense } from 'react';
import UserSettingsInner from './UserSettingsInner.component';
import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
const BreadCrumbs = React.lazy(
  () => import('../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
import UserHomeDataProvider from '../../Utils/Users/UserHomeDataProvider';
/// User settings page
const UserSettings = () => {
  return (
    <AuthCheckUser>
      <HelmetHelper title="Settings" description="Update your user profile" />
      <UserSettingsMain>
        <Suspense fallback={<div>Loading breadcrumbs...</div>}>
          <BreadCrumbs one="My Dashboard" oneLink={`/user`} two="Settings" />
        </Suspense>
        <h2>Update your profile</h2>
        <UserHomeDataProvider>
          {(user) => {
            return <UserSettingsInner user={user} />;
          }}
        </UserHomeDataProvider>
      </UserSettingsMain>
    </AuthCheckUser>
  );
};

export default UserSettings;
